import React, { Component } from 'react';
import { Icon } from '../../../ui/Icon';

export default class getAnchor extends Component {
  state = { anchorLink: '' };

  prepareCTALinkObj = () => {
    const { link, LocationInformation } = this.props;
    // prepare dynamic links
    let anchorHref = link;

    if (anchorHref && anchorHref.includes('{') && anchorHref.includes('?')) {
      let anchorLinkArr = anchorHref.split('?');
      const params = new URLSearchParams(anchorLinkArr[1]);

      for (const param of params) {
        if (param[1].includes('{')) {
          params.set(
            param[0],
            LocationInformation[param[0]] ? LocationInformation[param[0]] : '',
          );
        }
      }

      anchorHref = anchorLinkArr[0] + '?' + params.toString();
    }

    this.setState({ anchorLink: anchorHref });
  };

  componentDidMount() {
    this.prepareCTALinkObj();
  }

  render() {
    const { anchorLink } = this.state;
    const { text } = this.props;
    if (!anchorLink) {
      return null;
    }
    return (
      <a href={anchorLink}>
        <span>{text}</span>
        <span>
          <Icon name="chevron-right" />
        </span>
      </a>
    );
  }
}
